<div class="card">
	<h2>Login with Schwab</h2>
	<button pButton icon="pi pi-sign-in" class="mr-2" (click)="login()"> Login</button>
	<button pButton icon="pi pi-refresh" class="mr-2" (click)="refresh()"> Refresh</button>
	<button pButton icon="pi pi-sign-out" class="mr-2" (click)="logout()"> Logout</button>
</div>
